import type { TutorialStep } from '../components/TutorialOverlay';

export const TUTORIAL_STEPS: TutorialStep[] = [
  {
    id: 'story',
    title: 'This is Mira\u2019s quest',
    body:
      'The bar at the top always tells you the quest (win the Candle Crown before Vell lights it), what Mira needs right now, and where you are: chapter and scene. Story so far recaps everything that happened.',
  },
  {
    id: 'intent',
    title: 'I announce a plan. You ruin it.',
    body:
      'Every scene I read the scene, then announce my plan from Vell\u2019s outline. You answer with cards. If you let my plan through untouched it costs Dread +2 at scene end, and with one card it costs +1. Play two or more cards to bend it, or a Counter to block it outright, and it costs nothing.',
  },
  {
    id: 'select_card',
    title: 'Pick a card',
    body: 'Tap a card in your hand. It lifts and shows its cost in Ink, what it does, and its type\u2019s risk: Keepsakes are steady, Twists and Chaos are gambles, Rule-breakers may refund Ink, and Counters guard without building an ending. On desktop you can also drag a card upward to play it.',
  },
  {
    id: 'select_target',
    title: 'Pick a target',
    body:
      'Highlighted words in the story are targets, and so are the named buttons under the picture. Tap one. The picture marks where your card will land. The card must fit the target (a character card needs a character).',
  },
  {
    id: 'play',
    title: 'Play it',
    body: 'Hit Play card. The card flies into the scene and stamps the target. Ink is spent. End scene is only for when you are finished.',
  },
  {
    id: 'outcome',
    title: 'See what changed',
    body:
      'My original line gets struck through and rewritten, and What changed lists exactly what your card did: the change, Dread, and which ending meter moved. Lasting changes stay pinned to the picture and come back in later scenes.',
  },
  {
    id: 'draft',
    title: 'Wrap up, then tune your deck',
    body:
      'After End scene you get a short summary: your cards, whether my plan happened, and how the meters moved. Then pick one deck change (add, upgrade, remove) or skip. Reach your ending\u2019s number before the run ends (a full book asks three times what one chapter does), and keep Dread under 10. Miss the number and another ending decides.',
  },
];

/** Steps that wait for a Got it tap instead of a player action. */
export const TUTORIAL_INFO_STEPS = ['story', 'intent', 'outcome', 'draft'];
